export function formatTemplatesCount(count: number): string {
	if (count === 0) return 'Нет шаблонов';
	if (count === 1) return '1 шаблон';
	if (count >= 2 && count <= 4) return `${count} шаблона`;
	return `${count} шаблонов`;
}
